import { FC } from "react";
import { classes, style } from "typestyle";
import { NavigationBar } from "./navigation-bar.element";
import { TabBar } from "./tab-bar.element";

interface IProps {
  hideNavs?: boolean;
  hideGoBack?: boolean;
  isNavigationDisabled?: boolean;

  title?: string;
  hideProfile?: boolean;
  className?: string;
}

export const Page: FC<IProps> = (props) => {
  const queryParams = new URLSearchParams(window.location.search);
  const isNavigationDisabled =
    props.isNavigationDisabled ||
    queryParams.get("disable-navigation") === "true";
  return (
    <>
      {props.hideNavs !== true && (
        <>
          <NavigationBar
            hideProfile={props.hideProfile}
            title={props.title}
            hideGoBack={isNavigationDisabled || props.hideGoBack}
          />
          <div
            className={classes(
              isNavigationDisabled ? styles.fullHeightContent : styles.content,
              props.className,
            )}
          >
            {props.children}
          </div>
          {isNavigationDisabled !== true && <TabBar />}
        </>
      )}
      {props.hideNavs && (
        <div
          className={classes(
            styles.content,
            styles.hiddenNavs,
            props.className,
          )}
        >
          {props.children}
        </div>
      )}
    </>
  );
};
const styles = {
  content: style({
    marginTop: "calc(var(--nav-bar-height) + env(safe-area-inset-top))",
    marginBottom: "calc(var(--tab-bar-height) + env(safe-area-inset-bottom))",
    width: "100%",
  }),
  fullHeightContent: style({
    marginTop: "calc(var(--nav-bar-height) + env(safe-area-inset-top))",
    marginBottom: "env(safe-area-inset-bottom)",
    width: "100%",
  }),
  hiddenNavs: style({
    marginTop: 0,
    marginBottom: 0,
  }),
};
